import styled from 'styled-components';

interface TextProps {
  color?: string;
  fontWeight?: string | number;
  fontSize?: string | number;
}
export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Text = styled.span<TextProps>`
  width: 70%;
  text-align: center;
  color: ${({ color }) => color};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
